<template>
  <div class="trainings-page mt-4">
    <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
    <app-page-header title="Treinamentos"></app-page-header>

    <div class="container-md">
      <div class="row">
        <div
          v-for="training in data"
          :key="`training-${training.id}`"
          class="col-xl-4 col-sm-6"
        >
          <training-card
            @click="viewTraining(training)"
            class="training-card"
            :training="training"
          />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12">
          <b-pagination
            @change="onPageChange"
            :total="total"
            :current.sync="page"
            :per-page="perPage"
            :range-before="1"
            :range-after="1"
            aria-next-label="Próxima página"
            aria-previous-label="Página anterior"
            aria-page-label="Página"
            aria-current-label="Página atual"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TrainingService from '@/services/training.service';
import TrainingCard from '@/components/Training/TrainingCard.vue';

export default {
  name: 'trainings-page',
  components: {
    TrainingCard,
  },
  data: () => {
    return {
      isLoading: false,
      data: [],
      perPage: 10,
      page: 1,
      total: 0,
    };
  },
  methods: {
    loadTrainings() {
      this.isLoading = true;

      return TrainingService.get({
        page: this.page,
        perPage: this.perPage,
      })
        .then((response) => {
          const { data, total } = response.data;

          this.total = total;
          this.data = data;
        })
        .finally(() => (this.isLoading = false));
    },
    onPageChange(page) {
      this.page = page;
      this.loadTrainings().then(() => {
        document.body.scrollTop = 250;
        document.documentElement.scrollTop = 250;
      });
    },
    viewTraining(training) {
      this.$router.push({
        name: 'site.trainings.view',
        params: { id: training.id },
      });
    },
  },
  beforeMount() {
    this.loadTrainings();
  },
};
</script>

<style lang="scss" scoped>
.trainings-page {
  position: relative;
}

.training-card {
  margin: 1em auto;
  transition: 200ms ease-in-out;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
  }
}
</style>
